/* eslint-disable no-inline-comments */
/* eslint-disable max-len */
/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { LIGHTBLUE, RED, LIGHTGREY } from "../../utils/color_utils";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import SendIcon from "@material-ui/icons/Send";
import {
  Grid,
  Typography,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormGroup,
  TextField,
  Tab,
  Tabs,
  NoSsr,
  AppBar,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  InputLabel
} from "@material-ui/core";
import { getAllCompanySettings, getAllGeneralSettings } from '../../store/actions/companyAdminActions'
import { VisibilityOff, Visibility } from "@material-ui/icons";
import ContentCopy from '@mui/icons-material/ContentCopy';
import {
  SHOW_TOAST,
  UPDATE_USER_SUCCESS,
  CLEAR_UPDATE_USER_SUCCESS,
  GET_ALL_COMPANY_SETTINGS,
  GET_ALL_GENERAL_SETTINGS
} from "../../store/actions/types";
import {
  updateUserProfile,
  updateUserPassword,
  showUserProfile
} from "../../store/actions/userDialogActions";
import { showToast, clearStates } from "../../store/actions/toastAction";
//import { getOpinions } from "../../store/actions/opinionActions";
import { bindActionCreators } from 'redux'
import { Checkbox } from '@material-ui/core'
import { withRouter } from "react-router-dom";
import CryptoJS from 'crypto-js';
// WhatsApp OTP service - COMMENTED OUT (no longer used)
// import { sendWhatsAppOTP, verifyWhatsAppOTPCode } from '../../services/whatsappService';
// Import TOTP for Google Authenticator
import * as OTPAuth from 'otpauth';
import QRCode from 'qrcode';
import firebase from "../../config/fbConfig";

const tableM = {
  color: "#515A5A",
  fontSize: 15,
  border: "0px",
  backgroundColor: '#F2F3F4',
  padding: 1,
  borderRadius: 2
}
const tableC = {
  color: "#ffffff",
  fontSize: 15,
  border: "0px",
  padding: 1,
  borderRadius: 2,
  fontweight: 'bold',
  backgroundColor: '#515A5A'
}
const tableMh = {
  color: "#515A5A",
  fontSize: 15,
  border: "2px",
  backgroundColor: '#F2F3F4',
  padding: 1,
  borderRadius: 2
}
const tableS = {
  color: "#515A5A",
  fontSize: 10,
  border: "0px",
  backgroundColor: '#F2F3F4',
  padding: 1,
  borderRadius: 2
}
const tableH = {
  color: "#515A5A",
  fontSize: 14,
  border: "0px",
  backgroundColor: '#F2F3F4',
  padding: 10,
  borderRadius: 2
}

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 10, minHeight: "90vh" }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

function LinkTab(props) {
  return (
    <Tab component="a" onClick={event => event.preventDefault()} {...props} />
  );
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  tabsRoot: {
    backgroundColor: `${LIGHTBLUE}`
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "40%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  }
});

class UserTabs extends React.Component {
  state = {
    value: 0,
    firstName: "",
    lastName: "",
    calfname: "",
    calfemail: "",
    calfpassword: "",
    showPassword: "",
    biography: "",
    wallet: "",
    cellphone: "",
    privateKey: "",
    mevInWallet: "",
    bnbInWallet: "",
    showKey: false,
    copyKey: false,
    email: "",
    userURL: "",
    password: "",
    confirmPassword: "",
    showPassword: false,
    showConfirmPassword: false,
    receivePLDPEmails: false,
    receiveEmails: false,
    // receiveWhatsAppSecurity: false, // COMMENTED OUT - no longer using WhatsApp OTP
    // otpMethod: "whatsapp", // COMMENTED OUT - no longer using WhatsApp OTP
    unsavedchanges: false,
    userID: "",
    uid: "",
    department: "",
    position: "",
    nationality: "",
    self: 0,
    selfparticipants: 0,
    selfopinion: "",
    others: 0,
    othersopinion: "",
    othersparticipants: 0,
    organisation: 0,
    orgopinion: "",
    orgparticipants: 0,
    society: 0,
    sosopinion: "",
    sosparticipants: 0,
    feedbackOn: true,
    gfeedbackOn: true,
    demoOn: true,
    purpose: this.props.userdetails[0].userType === 8 ? false : true,
    // validPhone: true, // COMMENTED OUT - no longer using phone verification
    userType: this.props.userdetails[0].userType,
    companyID: "",
    custodialwallet: "",
    defaultSecurityLevel: 'level1',
    // Phone verification states - COMMENTED OUT (no longer using WhatsApp OTP)
    // phoneVerificationOTP: '',
    // showPhoneOTPField: false,
    // phoneOTPSent: false,
    // pendingPhoneNumber: '',
    // isVerifyingPhone: false,
    // originalPhoneNumber: '',
    // TOTP (Google Authenticator) states
    totpSecret: '',
    totpQRCode: '',
    showTOTPSetup: false,
    totpEnabled: false,
    showTOTPSecret: false,
    // TOTP verification states
    totpVerificationCode: '',
    isVerifyingTOTP: false,
    // Custodial wallet TOTP protection
    walletOTPCode: '',
    isVerifyingWalletOTP: false,
    walletAccessGranted: false,
    inactiveTime: 0, // default value
  };

  // Timer reference for auto-locking wallet after 10 minutes
  walletAutoLockTimer = null;

  handleTabChange = (event, value) => {
    if (this.state.unsavedchanges) {
      var params = {
        type: "SHOW_TOAST",
        open: true,
        variant: "warning",
        message: "Please save current changes first."
      };

      this.props.showToast(params);
      return;
    }

    this.setState({
      ...this.state,
      value,
      walletAccessGranted: false // STRICT SECURITY: Always lock wallet when changing tabs
    });
  };

  setInactiveTime = (value) => {
    this.setState({ inactiveTime: value });
  };

  handleChange = prop => event => {
    if (prop === "receiveEmails" || prop === "receivePLDPEmails") {
      this.setState({
        [prop]: JSON.parse(event.target.value),
        unsavedchanges: true
      });
    } else this.setState({ [prop]: event.target.value, unsavedchanges: true });
  };

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };
  handleClickConfirmPassword = () => {
    this.setState(state => ({
      showConfirmPassword: !state.showConfirmPassword
    }));
  };
  handlePasswordStrength(password) {
    var strengthMessage = "Strength: ";
    if (!password.length) return strengthMessage + "None";
    if (password.length < 8) return strengthMessage + "Weak";
    var hasUpperCase = /[A-Z]/.test(password);
    var hasLowerCase = /[a-z]/.test(password);
    var hasNumbers = /\d/.test(password);
    var hasNonalphas = /\W/.test(password);
    if (hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas > 3) {
      return strengthMessage + " Strong";
    } else {
      return strengthMessage + "Medium";
    }
  }

  updateUserProfile = () => {
    if (!this.state.firstName.trim()) {
      var params = {
        type: SHOW_TOAST,
        open: true,
        variant: "warning",
        message: "Firstname is required!"
      };

      this.props.showToast(params);
      return;
    }

    if (!this.state.lastName.trim()) {
      var params = {
        type: SHOW_TOAST,
        open: true,
        variant: "warning",
        message: "Lastname is required!"
      };

      this.props.showToast(params);
      return;
    }

    var body = {
      ...this.state
    };

    // Post CHANGES
    this.props.updateProfileChanges(body);
  };

  changeUserPassword = () => {
    if (!this.state.password.trim()) {
      var params = {
        type: SHOW_TOAST,
        open: true,
        variant: "warning",
        message: "Password is required!"
      };

      this.props.showToast(params);
      return;
    }

    if (!this.state.confirmPassword.trim()) {
      var params = {
        type: SHOW_TOAST,
        open: true,
        variant: "warning",
        message: "Confirm password is required!"
      };

      this.props.showToast(params);
      return;
    }

    if (this.state.password.trim() !== this.state.confirmPassword.trim()) {
      var params = {
        type: SHOW_TOAST,
        open: true,
        variant: "warning",
        message: "Password and confirm password do not match!"
      };

      this.props.showToast(params);
      return;
    }

    var body = {
      ...this.state
    };

    // Post CHANGES
    this.props.updateUserPassword(body);
  };

  cancelUserChanges = () => {
    this.setState({
      ...this.state,
      firstName: this.props.userdetails[0].firstName || "",
      lastName: this.props.userdetails[0].lastName || "",
      department: this.props.userdetails[0].department || "",
      position: this.props.userdetails[0].position || "",
      nationality: this.props.userdetails[0].nationality || "",
      calfemail: this.props.userdetails[0].calfemail || "",
      calfpassword: this.props.userdetails[0].calfpassword || "",
      biography: this.props.userdetails[0].biography || "",
      wallet: this.props.userdetails[0].wallet || "",
      cellphone: this.props.userdetails[0].cellphone || "",
      custodialwallet: this.props.userdetails[0].custodialwallet || "",
      privateKey: this.props.userdetails[0].privateKey || "",
      mevInWallet: this.props.userdetails[0].mevInWallet || "",
      bnbInWallet: this.props.userdetails[0].bnbInWallet || "",
      showKey: false,
      receivePLDPEmails: this.props.userdetails[0].receivePLDPEmails || false,
      receiveEmails: this.props.userdetails[0].receiveEmails || false,
      // receiveWhatsAppSecurity: this.props.userdetails[0].receiveWhatsAppSecurity || false, // COMMENTED OUT
      // otpMethod: this.props.userdetails[0].otpMethod || "whatsapp", // COMMENTED OUT
      defaultSecurityLevel: this.props.userdetails[0].defaultSecurityLevel || 'level1',
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      unsavedchanges: false,
      // Reset phone verification states - COMMENTED OUT (no longer using)
      // phoneVerificationOTP: '',
      // showPhoneOTPField: false,
      // phoneOTPSent: false,
      // pendingPhoneNumber: '',
      // isVerifyingPhone: false,
      // originalPhoneNumber: this.props.userdetails[0].cellphone || ''
      walletAccessGranted: false // STRICT SECURITY: Lock wallet on cancel
    });

    this.props.history.goBack();
  };

  componentDidUpdate = () => {
    var self = this;

    if (this.props.UPDATE_USER === UPDATE_USER_SUCCESS) {
      var params = {
        type: SHOW_TOAST,
        open: true,
        variant: "success",
        message: "Security settings updated successfully. Redirecting to dashboard..."
      };

      this.setState({
        ...this.state,
        unsavedchanges: false,
        walletAccessGranted: false // STRICT SECURITY: Lock wallet after successful update

      });

      // show success toast
      this.props.showToast(params);

      // clear success state
      this.props.clearStates({ type: CLEAR_UPDATE_USER_SUCCESS });

      // Reload states
      this.props.showUserProfile({ type: "SHOW_USER_PROFILE_DIALOG" });

      // Redirect to dashboard after successful update
      setTimeout(() => {
        this.props.history.push('/');
      }, 1500); // Wait 1.5 seconds to show the success message
    }
  };

  // phandleChange = prop => event => {
  //   this.setState({ [prop]: event.target.value });
  // };

  phandleMouseDownPassword = event => {
    event.preventDefault();
  };

  phandleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

 componentDidMount = () => {
   this.setState({
      ...this.state,
      value: 0,
      companyID: this.props.userdetails[0].companyID,
      firstName: this.props.userdetails[0].firstName || "",
      lastName: this.props.userdetails[0].lastName || "",
      calfname: this.props.userdetails[0].calfname || "",
      department: this.props.userdetails[0].department || "",
      position: this.props.userdetails[0].position || "",
      nationality: this.props.userdetails[0].nationality || "",
      calfemail: this.props.userdetails[0].calfemail || "",
      calfpassword: this.props.userdetails[0].calfpassword || "",
      biography: this.props.userdetails[0].biography || "",
      wallet: this.props.userdetails[0].wallet || "",
      cellphone: this.props.userdetails[0].cellphone || "",
      originalPhoneNumber: this.props.userdetails[0].cellphone || "", // Initialize original phone number
      custodialwallet: this.props.userdetails[0].custodialwallet || "",
      privateKey: this.props.userdetails[0].privateKey || "",
      //privateKey: this.encryptPrivateKey(this.props.userdetails[0].privateKey, this.props.userdetails[0].userID) || "",
      mevInWallet: this.props.userdetails[0].mevInWallet || "",
      bnbInWallet: this.props.userdetails[0].bnbInWallet || "",
      email: this.props.userdetails[0].email || "",
      userURL: this.props.userdetails[0].userURL || "",
      receivePLDPEmails: this.props.userdetails[0].receivePLDPEmails || true,
      receiveEmails: this.props.userdetails[0].receiveEmails || true,
      // receiveWhatsAppSecurity: this.props.userdetails[0].receiveWhatsAppSecurity || false, // COMMENTED OUT - no longer using
      // otpMethod: this.props.userdetails[0].otpMethod || "whatsapp", // COMMENTED OUT - no longer using
      defaultSecurityLevel: this.props.userdetails[0].defaultSecurityLevel || 'level1', // Default to Level 1 for new users
      userID: this.props.userdetails[0].userID,
      uid: this.props.userdetails[0].id,
      feedbackOn: this.props.userdetails[0].feedbackOn ? true : false,
      gfeedbackOn: this.props.userdetails[0].gfeedbackOn ? true : false,
      demoOn: this.props.userdetails[0].demoOn ? true : false,
      userType: this.props.userdetails[0].userType,
      userDescription: this.props.userdetails[0].userDescription,
      //purpose: this.props.userdetails[0].purpose ? true : false,
      //purpose: this.props.userdetails[0].userType === 8 ? false : !!this.props.userdetails[0].purpose
      purpose: this.props.userdetails[0].userType === 8 ? false : true,
      inactiveTime: this.props.userdetails[0].inactiveTime,
      // Load TOTP status
      totpSecret: this.props.userdetails[0].totpSecret || '',
      totpEnabled: this.props.userdetails[0].totpEnabled || false
    });



    this.props.getAllCompanySettings({
      companyID: this.props.userdata.companyID
    })
    this.props.getAllGeneralSettings({
      companyID: this.props.userdata.companyID
    })
    // this.props.getOpinions({
    //   leaderID: this.props.userdetails[0].userID
    // })
    this.putOpinions();
  };

  componentWillUnmount = () => {
    // Clean up
  };

  filterZZZ = (comLable) => {
    let comLablex = comLable.toString()
    let myTruncatedString = comLablex.substring(0, 4)
    let finalstring = comLablex

    if (myTruncatedString === 'ZZZ_') {
      finalstring = comLablex.substring(4, comLablex.length)
    }
    if (myTruncatedString === 'AAA_') {
      finalstring = comLablex.substring(4, comLablex.length)
    }
    return finalstring
  };

  renderCompanySettings = (type) => {
    let itemdata = null


    if (this.props.company_settings && this.props.company_settings[type]) {
      itemdata = this.props.company_settings[type];
      itemdata.sort()
      return itemdata.map((v, i) => (
        <MenuItem key={i} value={v}>
          {this.filterZZZ(v)}
        </MenuItem>
      ))
    }
  };
  renderGeneralSettings = (type) => {
    let itemdata = null

    if (this.props.general_settings && this.props.general_settings[type]) {
      itemdata = this.props.general_settings[type];
      // itemdata.sort()
      return itemdata.map((v, i) => (
        <MenuItem key={i} value={v}>
          {v}
        </MenuItem>
      ))
    }
  };

  handleChangeIndustry = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  };
  handleChangePosition = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  };
  handleChangeCountry = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  };

  putOpinions = () => {
    let { opinions } = this.props


    var self_count = 0;
    var others_count = 0;
    var organisation_count = 0;
    var society_count = 0;

    var self_all_count = 0;
    var others_all_count = 0;
    var org_all_count = 0;
    var sos_all_count = 0;

    if (opinions) {
      Object.keys(opinions).map((opinionsID, index) => {


        if (opinions[index].self) {
          self_all_count = self_all_count + 1;
          self_count = self_count + opinions[index].self
        }
        if (opinions[index].others) {
          others_all_count = others_all_count + 1;
          others_count = others_count + opinions[index].others
        }
        if (opinions[index].organisation) {
          org_all_count = org_all_count + 1;
          organisation_count = organisation_count + opinions[index].organisation
        }
        if (opinions[index].society) {
          sos_all_count = sos_all_count + 1;
          society_count = society_count + opinions[index].society
        }
      })
    }

    if (opinions) {
      this.setState({
        self: parseInt((self_count / self_all_count)),
        others: parseInt((others_count / others_all_count)),
        organisation: parseInt((organisation_count / org_all_count)),
        society: parseInt((society_count / sos_all_count)),
        selfparticipants: self_all_count,
        othersparticipants: others_all_count,
        orgparticipants: org_all_count,
        sosparticipants: org_all_count,
      })
    };
  }

  getOpinion = (props) => {
    for (let x in props) {
      return props[x].self
    }
  }

  handleFeedback = event => {
    this.setState({
      feedbackOn: event.target.checked
    })
  };

  handleFeedbackG = event => {
    this.setState({
      gfeedbackOn: event.target.checked
    })
  };

  handleDemo = event => {
    this.setState({
      demoOn: event.target.checked
    })
  };

  handlePurpose = event => {
    this.setState({
      purpose: event.target.checked
    })
  };

  toggleShowKey = () => {
    this.setState((prevState) => ({ showKey: !prevState.showKey }));
  };

  copyToClipboard = () => {
    const { privateKey, showKey } = this.state;
    //const textToCopy = showKey ? privateKey : '***********************';
    const textToCopy = this.decryptPrivateKey(privateKey, this.props.userdata.userID);

    var data = {
      type: "SHOW_TOAST",
      open: true,
      variant: 'warning',
      message: 'Private Key Copied to the clipboard. Protect your private Key at all times.'
    }
    navigator.clipboard.writeText(textToCopy).then(
      () => {

        try {
          this.props.showToast(data);
        } catch (err) {

        }
      },
      (err) => {
        // Failed to copy
      }
    );
  };

  encryptPrivateKey = (privateKey) => {
    const passphrase = "Lead54321";
    // Convert the private key to a WordArray (binary format)
    const wordArray = CryptoJS.enc.Hex.parse(privateKey.slice(2)); // Remove the "0x" prefix
    return CryptoJS.AES.encrypt(wordArray, passphrase).toString();
  }

  decryptPrivateKey = (encryptedKey) => {
    const passphrase = "Lead54321";


    try {
      // Decrypt the encrypted key
      const bytes = CryptoJS.AES.decrypt(encryptedKey, passphrase);
      // Convert the decrypted WordArray back to a hex string
      const decryptedHex = CryptoJS.enc.Hex.stringify(bytes);

      if (!decryptedHex) {
        throw new Error("Decryption failed. The resulting string is empty.");
      }

      // Add back the "0x" prefix to match the original format
      const decrypted = `0x${decryptedHex}`;


      return decrypted;
    } catch (error) {

      return null; // or handle the error as needed
    }
  };

  // decryptPrivateKey = (encryptedKey, userUID) => {

  //   const decipher = crypto.createDecipher('aes-256-cbc', userUID);
  //   let decrypted = decipher.update(encryptedKey, 'hex', 'utf8');
  //   decrypted += decipher.final('utf8');
  //   return decrypted;
  // }
  // copyToClipboard = () => {
  //   const { privateKey } = this.state;
  //   navigator.clipboard.writeText(privateKey)
  //     .then(() => {
  //          let params = {
  //     type: SHOW_TOAST,
  //     open: true,
  //     variant: 'Success',
  //     message: 'Private Key Copied to the clipboard'
  //    }
  //    this.props.showToast(params);

  //     })
  //     .catch((err) => {
  //     });
  // }

  // ============================================================
  // PHONE VERIFICATION METHODS - COMMENTED OUT (No longer using WhatsApp OTP)
  // ============================================================
  /*
  handleCellChange = event => {
    const { name, value } = event.target;
  
    // Check if user is trying to clear/remove the phone number
    if (value.trim() === '') {
      // User is removing their phone number

      
      // Show warning and automatically downgrade to Level 1
      const confirmRemoval = window.confirm(
        '⚠️ REMOVE PHONE NUMBER?\n\n' +
        'Removing your phone number will:\n' +
        '• Disable WhatsApp OTP security\n' +
        '• Automatically set your security to Level 1\n' +
        '• Make your account more vulnerable\n\n' +
        'Are you sure you want to continue?'
      );
      
      if (confirmRemoval) {
        // User confirmed removal
        this.setState({
          cellphone: '',
          validPhone: false,
          defaultSecurityLevel: 'level1', // Automatically downgrade to Level 1
          receiveWhatsAppSecurity: false, // Disable WhatsApp OTP
          unsavedchanges: true,
          // Reset any ongoing verification
          phoneVerificationOTP: '',
          showPhoneOTPField: false,
          phoneOTPSent: false,
          pendingPhoneNumber: '',
          isVerifyingPhone: false,
          originalPhoneNumber: ''
        });
        
        // Show security downgrade warning
        var warningParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "warning",
          message: "⚠️ SECURITY DOWNGRADED!\n\nYour phone number has been removed.\nSecurity level automatically set to Level 1.\nYour account is now more vulnerable.\n\nConsider adding a phone number for better security."
        };
        this.props.showToast(warningParams);
        
      } else {
        // User cancelled removal - revert to original phone number
        this.setState({
          cellphone: this.state.originalPhoneNumber || this.props.userdetails[0].cellphone || ''
        });
        
        var cancelParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "info",
          message: "Phone number removal cancelled."
        };
        this.props.showToast(cancelParams);
      }
      return;
    }
    
    // If the field is 'cellphone', validate the phone number format
    if (this.validatePhoneNumber(value)) {
       
      
      // Don't save immediately - trigger OTP verification first
      this.setState({
        pendingPhoneNumber: value,
        originalPhoneNumber: this.state.cellphone, // Store current phone to revert if needed
        isVerifyingPhone: true,
        showPhoneOTPField: false,
        phoneOTPSent: false,
        phoneVerificationOTP: ''
      });
      
      // Send OTP to the new phone number
      this.sendPhoneVerificationOTP(value);
      
    } else {
       
      var params = {
        type: SHOW_TOAST,
        open: true,
        variant: "warning",
        message: "Invalid phone number format! Please use international format (e.g., +1234567890)"
      };

      this.props.showToast(params);
      // Keep original phone number
      this.setState({
        cellphone: this.state.originalPhoneNumber || this.props.userdetails[0].cellphone || '',
        validPhone: false
      });
      return;
    }
  };

  // Send OTP to verify phone number ownership
  sendPhoneVerificationOTP = async (phoneNumber) => {
    try {
      // Show loading state
      var loadingParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "info",
        message: `📱 Sending verification code to ${phoneNumber}...`
      };
      this.props.showToast(loadingParams);

      // Use real WhatsApp OTP service
      const otpResponse = await sendWhatsAppOTP(phoneNumber);
      
      if (otpResponse.success) {
        this.setState({
          showPhoneOTPField: true,
          phoneOTPSent: true,
          isVerifyingPhone: true
        });
        
        var successParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "success",
          message: `✅ Verification code sent to ${phoneNumber}. Please check your WhatsApp messages.`
        };
        this.props.showToast(successParams);
        
      } else {
        throw new Error(otpResponse.error || 'Failed to send OTP');
      }
      
    } catch (error) {
      // Revert to original phone number
      this.setState({
        cellphone: this.state.originalPhoneNumber,
        pendingPhoneNumber: '',
        isVerifyingPhone: false,
        showPhoneOTPField: false,
        phoneOTPSent: false
      });
      
      var errorParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "error",
        message: `❌ Failed to send verification code to ${phoneNumber}. ${error.message || 'Please try again.'}`
      };
      this.props.showToast(errorParams);
    }
  };

  // Verify the OTP entered by user
  verifyPhoneOTP = async () => {
    try {
      const { phoneVerificationOTP, pendingPhoneNumber } = this.state;
      
      if (!phoneVerificationOTP || phoneVerificationOTP.length !== 6) {
        var params = {
          type: SHOW_TOAST,
          open: true,
          variant: "warning",
          message: "Please enter the 6-digit verification code."
        };
        this.props.showToast(params);
        return;
      }
      
      // Show loading state
      var loadingParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "info",
        message: "🔍 Verifying code..."
      };
      this.props.showToast(loadingParams);

      // Use real WhatsApp OTP verification service
      const verificationResponse = await verifyWhatsAppOTPCode(pendingPhoneNumber, phoneVerificationOTP);
      
      if (verificationResponse.success) {
        // OTP verified successfully - save the phone number
        this.setState({
          cellphone: pendingPhoneNumber,
          validPhone: true,
          unsavedchanges: true,
          // Reset verification states
          showPhoneOTPField: false,
          phoneOTPSent: false,
          isVerifyingPhone: false,
          phoneVerificationOTP: '',
          pendingPhoneNumber: '',
          originalPhoneNumber: ''
        });
        
        var successParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "success",
          message: `✅ Phone number ${pendingPhoneNumber} verified successfully! Don't forget to save your profile.`
        };
        this.props.showToast(successParams);
        
      } else {
        throw new Error(verificationResponse.error || 'Invalid verification code');
      }
      
    } catch (error) {
      var errorParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "error",
        message: `❌ ${error.message || 'Invalid verification code'}. Please try again.`
      };
      this.props.showToast(errorParams);
    }
  };

  // Cancel phone verification and revert to original number
  cancelPhoneVerification = () => {
    this.setState({
      cellphone: this.state.originalPhoneNumber,
      pendingPhoneNumber: '',
      isVerifyingPhone: false,
      showPhoneOTPField: false,
      phoneOTPSent: false,
      phoneVerificationOTP: ''
    });
    
    var params = {
      type: SHOW_TOAST,
      open: true,
      variant: "info",
      message: "Phone verification cancelled. Original number restored."
    };
    this.props.showToast(params);
  };

  // Resend OTP for phone verification
  resendPhoneOTP = () => {
    if (this.state.pendingPhoneNumber) {
      this.setState({
        phoneVerificationOTP: '',
        phoneOTPSent: false
      });
      this.sendPhoneVerificationOTP(this.state.pendingPhoneNumber);
    }
  };

  validatePhoneNumber = (phoneNumber) => {
    // Regex for phone number validation (starts with '+' followed by 1-3 digit country code and 7-15 digit number)
    const phoneRegex = /^\+\d{1,3}\d{7,15}$/;
  
    // Test if the phone number matches the pattern
    if (phoneRegex.test(phoneNumber)) {
      return true; // Valid phone number
    } else {
      return false; // Invalid phone number
    }
  };
  */
  // ============================================================
  // END OF COMMENTED OUT PHONE VERIFICATION METHODS
  // ============================================================

  // TOTP (Google Authenticator) Methods
  generateTOTPSecret = async () => {
    try {
      // Generate a new TOTP secret
      const totp = new OTPAuth.TOTP({
        issuer: 'ThinkLead',
        label: this.state.email,
        algorithm: 'SHA1',
        digits: 6,
        period: 30
      });

      // Generate a random secret
      const secret = OTPAuth.Secret.fromBase32(
        OTPAuth.Secret.fromUTF8(
          Array.from({ length: 20 }, () =>
            String.fromCharCode(65 + Math.floor(Math.random() * 26))
          ).join('')
        ).base32
      );

      totp.secret = secret;

      // Generate OTP Auth URL for QR code
      const otpauthURL = totp.toString();

      // Generate QR Code
      const qrCodeDataURL = await QRCode.toDataURL(otpauthURL);

      // Update state with secret and QR code
      this.setState({
        totpSecret: secret.base32,
        totpQRCode: qrCodeDataURL,
        showTOTPSetup: true,
        showTOTPSecret: false
      });

      var params = {
        type: SHOW_TOAST,
        open: true,
        variant: "success",
        message: "✅ TOTP Secret Generated! Scan the QR code with Google Authenticator or copy the secret key."
      };
      this.props.showToast(params);

    } catch (error) {
      console.error('Error generating TOTP:', error);
      var errorParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "error",
        message: "❌ Failed to generate TOTP secret. Please try again."
      };
      this.props.showToast(errorParams);
    }
  };

  saveTOTPSecret = async () => {
    try {
      if (!this.state.totpSecret) {
        var params = {
          type: SHOW_TOAST,
          open: true,
          variant: "warning",
          message: "⚠️ Please generate a TOTP secret first."
        };
        this.props.showToast(params);
        return;
      }

      // Save TOTP secret to Firebase
      const userRef = firebase.database().ref(`/user/${this.state.uid}`);
      await userRef.update({
        totpSecret: this.state.totpSecret,
        totpEnabled: true,
        totpSetupDate: Date.now()
      });

      this.setState({
        totpEnabled: true,
        showTOTPSetup: false,
        unsavedchanges: false
      });

      var successParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "success",
        message: "✅ TOTP Enabled! Your account is now secured with Google Authenticator."
      };
      this.props.showToast(successParams);

    } catch (error) {
      console.error('Error saving TOTP:', error);
      var errorParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "error",
        message: "❌ Failed to save TOTP secret. Please try again."
      };
      this.props.showToast(errorParams);
    }
  };

  disableTOTP = async () => {
    try {
      const confirmDisable = window.confirm(
        '⚠️ DISABLE GOOGLE AUTHENTICATOR?\n\n' +
        'This will remove TOTP authentication from your account.\n' +
        'Are you sure you want to continue?'
      );

      if (!confirmDisable) {
        return;
      }

      // Remove TOTP from Firebase
      const userRef = firebase.database().ref(`/user/${this.state.uid}`);
      await userRef.update({
        totpSecret: null,
        totpEnabled: false,
        totpSetupDate: null
      });

      this.setState({
        totpSecret: '',
        totpQRCode: '',
        totpEnabled: false,
        showTOTPSetup: false,
        showTOTPSecret: false
      });

      var params = {
        type: SHOW_TOAST,
        open: true,
        variant: "info",
        message: "ℹ️ TOTP has been disabled from your account."
      };
      this.props.showToast(params);

    } catch (error) {
      console.error('Error disabling TOTP:', error);
      var errorParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "error",
        message: "❌ Failed to disable TOTP. Please try again."
      };
      this.props.showToast(errorParams);
    }
  };

  copyTOTPSecret = () => {
    if (!this.state.totpSecret) {
      return;
    }

    navigator.clipboard.writeText(this.state.totpSecret).then(
      () => {
        var params = {
          type: SHOW_TOAST,
          open: true,
          variant: "success",
          message: "✅ TOTP Secret copied to clipboard!"
        };
        this.props.showToast(params);
      },
      (err) => {
        var errorParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "error",
          message: "❌ Failed to copy secret to clipboard."
        };
        this.props.showToast(errorParams);
      }
    );
  };

  toggleShowTOTPSecret = () => {
    this.setState((prevState) => ({
      showTOTPSecret: !prevState.showTOTPSecret
    }));
  };

  // Verify TOTP code entered by user
  verifyTOTPCode = async () => {
    try {
      const { totpVerificationCode, totpSecret } = this.state;

      if (!totpVerificationCode || totpVerificationCode.length !== 6) {
        var params = {
          type: SHOW_TOAST,
          open: true,
          variant: "warning",
          message: "⚠️ Please enter a 6-digit code from Google Authenticator."
        };
        this.props.showToast(params);
        return;
      }

      if (!totpSecret) {
        var errorParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "error",
          message: "❌ No TOTP secret found. Please setup TOTP first."
        };
        this.props.showToast(errorParams);
        return;
      }

      this.setState({ isVerifyingTOTP: true });

      // Create TOTP instance with user's secret
      const totp = new OTPAuth.TOTP({
        issuer: 'ThinkLead',
        label: this.state.email,
        algorithm: 'SHA1',
        digits: 6,
        period: 30,
        secret: OTPAuth.Secret.fromBase32(totpSecret)
      });

      // Verify the token (with window of +/- 1 period for clock skew)
      const delta = totp.validate({
        token: totpVerificationCode,
        window: 1
      });

      this.setState({ isVerifyingTOTP: false });

      if (delta !== null) {
        // Valid code!
        var successParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "success",
          message: `✅ SUCCESS! Code verified! Your TOTP is working perfectly. (Time delta: ${delta * 30}s)`
        };
        this.props.showToast(successParams);

        // Clear the input
        this.setState({ totpVerificationCode: '' });
      } else {
        // Invalid code
        var invalidParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "error",
          message: "❌ Invalid code! Please check:\n• Code is current (not expired)\n• Secret was entered correctly in Google Authenticator\n• Phone time is synced correctly"
        };
        this.props.showToast(invalidParams);
      }

    } catch (error) {
      console.error('Error verifying TOTP:', error);
      this.setState({ isVerifyingTOTP: false });

      var errorParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "error",
        message: `❌ Verification failed: ${error.message}`
      };
      this.props.showToast(errorParams);
    }
  };



  // Manual lock wallet
  lockWallet = () => {
    this.setState({ walletAccessGranted: false });

    var params = {
      type: SHOW_TOAST,
      open: true,
      variant: "info",
      message: "🔒 Custodial wallet locked successfully."
    };
    this.props.showToast(params);
  };

  // Verify TOTP code for wallet access
  verifyWalletOTP = async () => {
    try {
      const { walletOTPCode, totpSecret } = this.state;

      if (!walletOTPCode || walletOTPCode.length !== 6) {
        var params = {
          type: SHOW_TOAST,
          open: true,
          variant: "warning",
          message: "⚠️ Please enter a 6-digit code from Google Authenticator."
        };
        this.props.showToast(params);
        return;
      }

      this.setState({ isVerifyingWalletOTP: true });

      // Create TOTP instance with user's secret
      const totp = new OTPAuth.TOTP({
        issuer: 'ThinkLead',
        label: this.state.email,
        algorithm: 'SHA1',
        digits: 6,
        period: 30,
        secret: OTPAuth.Secret.fromBase32(totpSecret)
      });

      // Verify the token (with window of +/- 1 period for clock skew)
      const delta = totp.validate({
        token: walletOTPCode,
        window: 1
      });

      this.setState({ isVerifyingWalletOTP: false });

      if (delta !== null) {
        // Valid code! Grant wallet access
        this.setState({
          walletAccessGranted: true,
          walletOTPCode: ''
        });

        // STRICT SECURITY: No auto-lock timer. 
        // Wallet remains unlocked only until:
        // 1. User saves changes
        // 2. User cancels changes
        // 3. User switches tabs
        // 4. User refreshes page

        var successParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "success",
          message: "✅ Access granted!"
        };
        this.props.showToast(successParams);
      } else {
        // Invalid code
        var invalidParams = {
          type: SHOW_TOAST,
          open: true,
          variant: "error",
          message: "❌ Invalid code! Please enter the current code from Google Authenticator."
        };
        this.props.showToast(invalidParams);
      }

    } catch (error) {
      console.error('Error verifying wallet OTP:', error);
      this.setState({ isVerifyingWalletOTP: false });

      var errorParams = {
        type: SHOW_TOAST,
        open: true,
        variant: "error",
        message: `❌ Verification failed: ${error.message}`
      };
      this.props.showToast(errorParams);
    }
  };

  render() {
    const { classes, opinions } = this.props;
    const { value, showKey, privateKey } = this.state;

    return (
      <NoSsr>
        <div className={classes.root}>
          <AppBar position="static">
            <Tabs
              variant="fullWidth"
              value={value}
              onChange={this.handleTabChange}
              classes={{
                root: classes.tabsRoot
              }}
            >
              <LinkTab label="Profile Settings" href="page1" />
              <LinkTab label="Email Notifications" href="page2" />
              <LinkTab label="Security" href="page3" />
              <LinkTab label="Edit Password" href="page4" />
              <LinkTab label="Feedback" href="page5" />
            </Tabs>
          </AppBar>
          {value === 0 && (
            <TabContainer>
              <div>
                <Grid container spacing={8}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="firstName"
                      label="First name"
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      aria-describedby="First name"
                      value={this.state.firstName}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          firstName: value,
                          unsavedchanges: true
                        });
                      }}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="lastName"
                      label="Last name"
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      aria-describedby="lastName"
                      value={this.state.lastName}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          lastName: value,
                          unsavedchanges: true
                        });
                      }}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="biography"
                      aria-describedby="biography-content"
                      label="Biography"
                      fullWidth
                      multiline
                      rows="3"
                      margin="normal"
                      value={this.state.biography}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          biography: value
                        });
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="wallet"
                      aria-describedby="wallet-address"
                      label="MEV Wallet"
                      //helperText="readonly"
                      InputProps={{
                        readOnly: true
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.state.wallet}
                      fullWidth
                      required
                    />
                  </Grid>
                  {/* Private Key */}
                  {/* <Grid item xs={12} md={6}> */}
                  {/* <TextField
                      type={this.state.showKey? 'text' : 'key'}
                      label="Private Key"
                      variant="outlined"
                      value={this.state.showKey ? this.state.privateKey : '********************'}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.toggleShowKey}
                              edge="end"
                            >
                              {this.state.showKey ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                            ),                         
                           }}
                        /> */}
                  {/* <TextField
                      type={this.state.showKey ? 'text' : 'key'}
                      label="Private Key"
                      variant="outlined"
                      value={this.state.showKey ? this.decryptPrivateKey(this.state.privateKey, this.props.userdata.userID) : '********************'}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={this.toggleShowKey} edge="end">
                              {this.state.showKey ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                            <IconButton onClick={this.copyToClipboard} edge="end">
                              <ContentCopy />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    /> */}
                  {/* </Grid> */}
                  {/* Private Key */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="mev"
                      aria-describedby="mev-In-Wallet"
                      InputProps={{
                        readOnly: true
                      }}
                      //helperText="MEV Wallet"
                      label="MEV In Wallet"
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.state.mevInWallet + ' MEV'}
                      fullWidth
                      required
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="bnb"
                      aria-describedby="bnb-In-Wallet"
                      InputProps={{
                        readOnly: true
                      }}
                      //helperText="MEV Wallet"
                      label="BNB In Wallet"
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.state.bnbInWallet + ' BNB'}
                      fullWidth
                      required
                    />
                  </Grid>

                  {/* Custodial Wallet - Protected by TOTP */}
                  <Grid item xs={12} md={6}>
                    {!this.state.totpEnabled ? (
                      // Case 1: TOTP not enabled - Prompt to enable
                      <div style={{
                        padding: '20px',
                        backgroundColor: '#fff3cd',
                        border: '2px solid #ffc107',
                        borderRadius: '8px',
                        marginTop: '16px'
                      }}>
                        <Typography variant="h6" style={{
                          color: '#856404',
                          fontWeight: 'bold',
                          marginBottom: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          🔒 Custodial Wallet (TOTP Protected)
                        </Typography>
                        <Typography variant="body2" style={{
                          color: '#856404',
                          marginBottom: '15px'
                        }}>
                          This field requires Google Authenticator (TOTP) protection for security.
                        </Typography>
                        <Typography variant="body2" style={{
                          color: '#856404',
                          fontWeight: 'bold'
                        }}>
                          ⚠️ Please enable TOTP in the Security tab before accessing this field.
                        </Typography>
                        <Button
                          variant="outlined"
                          style={{
                            marginTop: '15px',
                            color: '#856404',
                            borderColor: '#ffc107',
                            backgroundColor: 'white'
                          }}
                          onClick={() => this.handleTabChange(null, 2)}
                        >
                          Go to Security Tab
                        </Button>
                      </div>
                    ) : !this.state.walletAccessGranted ? (
                      // Case 2: TOTP enabled but not verified - Show OTP verification
                      <div style={{
                        padding: '20px',
                        backgroundColor: '#e3f2fd',
                        border: '2px solid #2196f3',
                        borderRadius: '8px',
                        marginTop: '16px'
                      }}>
                        <Typography variant="h6" style={{
                          color: '#0d47a1',
                          fontWeight: 'bold',
                          marginBottom: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          🔐 Verify Your Identity
                        </Typography>
                        <Typography variant="body2" style={{
                          color: '#0d47a1',
                          marginBottom: '15px'
                        }}>
                          Enter the current code from Google Authenticator to access your custodial wallet.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Enter 6-digit TOTP Code"
                          value={this.state.walletOTPCode}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                            this.setState({ walletOTPCode: value });
                          }}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter' && this.state.walletOTPCode.length === 6) {
                              this.verifyWalletOTP();
                            }
                          }}
                          inputProps={{
                            maxLength: 6,
                            style: {
                              fontSize: '24px',
                              letterSpacing: '8px',
                              textAlign: 'center',
                              fontWeight: 'bold'
                            }
                          }}
                          placeholder="000000"
                          style={{ marginBottom: '15px' }}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          onClick={this.verifyWalletOTP}
                          disabled={this.state.walletOTPCode.length !== 6 || this.state.isVerifyingWalletOTP}
                          style={{
                            padding: '12px',
                            fontWeight: 'bold'
                          }}
                        >
                          {this.state.isVerifyingWalletOTP ? 'Verifying...' : 'Verify & Access Wallet'}
                        </Button>
                      </div>
                    ) : (
                      // Case 3: TOTP verified - Show actual wallet field
                      <div>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          marginBottom: '5px',
                          marginTop: '16px'
                        }}>
                          <Typography variant="caption" style={{
                            color: '#28a745',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                          }}>
                            ✅ Identity Verified
                          </Typography>
                          <Button
                            size="small"
                            onClick={this.lockWallet}
                            style={{
                              fontSize: '11px',
                              padding: '2px 8px',
                              color: '#666'
                            }}
                          >
                            Lock
                          </Button>
                        </div>
                        <TextField
                          id="custodialwallet"
                          label="custodialwallet"
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          aria-describedby="custodialwallet"
                          value={this.state.custodialwallet}
                          onChange={event => {
                            const { value } = event.target;
                            this.setState({
                              custodialwallet: value,
                            });
                          }}
                          inputProps={{
                            name: 'custodialwallet',
                            id: 'custodialwallet'
                          }}
                          fullWidth
                          required
                        />
                      </div>
                    )}
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      InputProps={{
                        readOnly: true
                      }}
                      id="email"
                      aria-describedby="email-content"
                      label="Email"
                      fullWidth
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.state.email}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          email: value
                        });
                      }}
                    //helperText="readonly"
                    />
                  </Grid>

                  {/* CELLPHONE FIELD - COMMENTED OUT (no longer using WhatsApp OTP)
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="cellphone"
                      label="cellphone"
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      aria-describedby="cellphone"
                      value={this.state.cellphone}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          cellphone: value,
                        });
                      }}
                      onBlur={e => this.handleCellChange(e)} 
                      autoComplete="new-cellphone"
                      inputProps={{
                        name: 'cellphone',
                        id: 'cellphone'
                      }}
                      fullWidth
                      required
                    />
                    
                    {/* Phone Verification UI */}
                  {/*this.state.isVerifyingPhone && (
                      <div style={{ 
                        marginTop: '10px', 
                        padding: '15px', 
                        backgroundColor: '#e3f2fd', 
                        border: '2px solid #2196f3',
                        borderRadius: '8px' 
                      }}>
                        <Typography variant="h6" style={{ 
                          fontWeight: 'bold', 
                          marginBottom: '10px',
                          color: '#1976d2',
                          textAlign: 'center'
                        }}>
                          📱 Verify Phone Number
                        </Typography>
                        
                        <Typography variant="body2" style={{ 
                          marginBottom: '15px',
                          color: '#1976d2',
                          textAlign: 'center'
                        }}>
                          {this.state.phoneOTPSent 
                            ? `Verification code sent to ${this.state.pendingPhoneNumber}`
                            : 'Sending verification code...'
                          }
                        </Typography>
                        
                        {this.state.showPhoneOTPField && (
                          <>
                            <TextField
                              variant='outlined'
                              margin='dense'
                              placeholder='Enter 6-digit verification code'
                              value={this.state.phoneVerificationOTP}
                              fullWidth
                              onChange={(event) => {
                                const { value } = event.target;
                                this.setState({
                                  phoneVerificationOTP: value
                                });
                              }}
                              style={{ 
                                backgroundColor: '#fff', 
                                borderRadius: 5,
                                marginBottom: '10px'
                              }}
                              inputProps={{
                                maxLength: 6,
                                pattern: "[0-9]*",
                                inputMode: "numeric",
                                style: { 
                                  textAlign: 'center', 
                                  fontSize: '18px', 
                                  letterSpacing: '2px' 
                                }
                              }}
                            />
                            
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                              <Button
                                variant='contained'
                                onClick={this.verifyPhoneOTP}
                                style={{ 
                                  backgroundColor: '#4caf50',
                                  color: 'white',
                                  fontWeight: 'bold',
                                  textTransform: 'none'
                                }}
                              >
                                ✅ Verify Code
                              </Button>
                              
                              <Button
                                variant='outlined'
                                onClick={this.resendPhoneOTP}
                                style={{ 
                                  borderColor: '#1976d2',
                                  color: '#1976d2',
                                  textTransform: 'none'
                                }}
                              >
                                🔄 Resend Code
                              </Button>
                              
                              <Button
                                variant='text'
                                onClick={this.cancelPhoneVerification}
                                style={{ 
                                  color: '#f44336',
                                  textTransform: 'none'
                                }}
                              >
                                ❌ Cancel
                              </Button>
                            </div>
                          </>
                        )}
                        
                        {!this.state.showPhoneOTPField && this.state.phoneOTPSent && (
                          <div style={{ textAlign: 'center' }}>
                            <Typography variant="body2" style={{ color: '#666', marginBottom: '10px' }}>
                              Waiting for verification code...
                            </Typography>
                            <Button
                              variant='text'
                              onClick={this.cancelPhoneVerification}
                              style={{ 
                                color: '#f44336',
                                textTransform: 'none'
                              }}
                            >
                              ❌ Cancel Verification
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  </Grid>
                  */}
                  {/* END OF COMMENTED OUT CELLPHONE FIELD */}

                  <Grid item xs={12} md={6}>
                    <TextField
                      InputProps={{
                        readOnly: true
                      }}
                      id="userURL"
                      aria-describedby="userURL-content"
                      label="Personalized invite link"
                      fullWidth
                      margin="normal"
                      //value={this.state.userURL}
                      value={"thinklead.app/?id=" + this.props.userdata.companyID + "&u=" + this.props.userdata.uid}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          userURL: value
                        });
                      }}
                      helperText="readonly"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    {/* <TextField
                      autoFocus
                      id="industry"
                      label="Industry"
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      aria-describedby="Industry"
                      value={this.state.industry}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          industry: value,
                          unsavedchanges: true
                        });
                      }}
                      fullWidth
                      required
                    /> */}
                    <FormControl fullWidth>
                      <InputLabel htmlFor='department'>Sector</InputLabel>
                      <Select
                        value={this.state.department}
                        onChange={e => this.handleChangeIndustry(e, 'department')}
                        inputProps={{
                          name: 'department',
                          id: 'department'
                        }}
                      >
                        {this.renderCompanySettings('departments')}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* <Grid item xs={12} md={6}>
                    <TextField
                      autoFocus
                      id="calfemail"
                      label="Executive Club Email"
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      aria-describedby="calfemail"
                      value={this.state.calfemail}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          calfemail: value,
                          unsavedchanges: true
                        });
                      }}
                      fullWidth
                      required
                    />
                  </Grid> */}

                  {/* <Grid item xs={12} md={6}>
                  <TextField
                      id="calfpassword"
                      placeholder="Calf password"
                      type={this.state.showPassword ? 'text' : 'password'}
                      value={this.state.calfpassword}
                      label="Calf Password"
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      aria-describedby="calfpassword"
                      // onChange={this.phandleChange('calfpassword')}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          calfpassword: value,
                          unsavedchanges: true
                        });
                      }}
                      InputProps={{
                        endAdornment:(
                       <InputAdornment position="end" >
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.phandleClickShowPassword}
                          onMouseDown={this.phandleMouseDownPassword}
                        >
                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                         </InputAdornment>
                        )
                      }}
                    /> */}

                  {/* <TextField
                      id="calfpassword"
                      label="Executive Club Password"
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      aria-describedby="calfpassword"
                      value={this.state.calfpassword}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({
                          calfpassword: value,
                          unsavedchanges: true
                        });
                      }}
                      fullWidth
                      required
                    /> 
                  </Grid>  */}
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor='position'>Position/Title</InputLabel>
                      <Select
                        value={this.state.position}
                        onChange={e => this.handleChangePosition(e, 'position')}
                        inputProps={{
                          name: 'position',
                          id: 'position'
                        }}
                      >
                        {this.renderGeneralSettings('position')}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor='country'>Country</InputLabel>
                      <Select
                        value={this.state.nationality}
                        onChange={e => this.handleChangeCountry(e, 'nationality')}
                        inputProps={{
                          name: 'nationality',
                          id: 'nationality'
                        }}
                      >
                        {this.renderGeneralSettings('countriesb')}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* TOTP COMPONENT MOVED TO SECURITY TAB - View it when selecting Level 2 Security */}

                  <Grid item xs={12} md={6}>
                    {/* <FormControl fullWidth> */}
                    <InputLabel htmlFor='feedbackOn'>Feedback Display</InputLabel>
                    <Checkbox
                      inputProps={{ 'aria-labelledby': 'select-all-users' }}
                      checked={this.state.feedbackOn ? true : false}
                      //checked={this.props.userdetails[0].feedbackOn ? true : false}
                      onChange={e => {
                        this.handleFeedback(e)
                      }}
                    />
                    {/* </FormControl> */}
                    {/* <FormControl fullWidth> */}
                    <InputLabel htmlFor='gfeedbackOn'>Global Feedback Display</InputLabel>
                    <Checkbox
                      inputProps={{ 'aria-labelledby': 'select-all-users' }}
                      checked={this.state.gfeedbackOn ? true : false}
                      //checked={this.props.userdetails[0].gfeedbackOn ? true : false}
                      onChange={e => {
                        this.handleFeedbackG(e)
                      }}
                    />
                    <InputLabel htmlFor='demo'>Demo Account</InputLabel>
                    <Checkbox
                      inputProps={{ 'aria-labelledby': 'select-all-users' }}
                      checked={this.state.demoOn ? true : false}
                      //checked={this.props.userdetails[0].gfeedbackOn ? true : false}
                      onChange={e => {
                        this.handleDemo(e)
                      }}
                    />

                    <InputLabel htmlFor='purp'>I have discovered my purpose</InputLabel>
                    <Checkbox
                      inputProps={{ 'aria-labelledby': 'select-all-users' }}
                      checked={this.state.purpose ? true : false}
                      //checked={this.props.userdetails[0].gfeedbackOn ? true : false}
                      onChange={e => {
                        this.handlePurpose(e)
                      }}
                    />

        <h6><b>Inactive Timeout in minutes (Lev 2)</b></h6>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <label style={{ cursor: 'pointer' }}>
           &nbsp;&nbsp; <input
              type="radio"
              name="inactiveTime"
              value={0}
              checked={this.state.inactiveTime === 0}
              onChange={() => this.setInactiveTime(0)}
            />
            {' '}0 minutes (Never)
          </label>

          <label style={{ cursor: 'pointer' }}>
            &nbsp;&nbsp; <input
              type="radio"
              name="inactiveTime"
              value={3}
              checked={this.state.inactiveTime === 3}
              onChange={() => this.setInactiveTime(3)}
            />
            {' '}3 minutes
          </label>

          <label style={{ cursor: 'pointer' }}>
            &nbsp;&nbsp; <input
              type="radio"
              name="inactiveTime"
              value={30}
              checked={this.state.inactiveTime === 30}
              onChange={() => this.setInactiveTime(30)}
            />
            {' '}30 minutes
          </label>

          <label style={{ cursor: 'pointer' }}>
            &nbsp;&nbsp; <input
              type="radio"
              name="inactiveTime"
              value={60}
              checked={this.state.inactiveTime === 60}
              onChange={() => this.setInactiveTime(60)}
            />
            {' '}60 minutes
          </label>
        </div>

        {/* Optional: Display current value */}
        <p style={{ marginTop: '20px' }}>
          Current inactive time: <strong>{this.state.inactiveTime} minutes</strong>
        </p>

                    {/* </FormControl>                   */}
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      style={{ backgroundColor: RED, color: "#fff" }}
                      onClick={this.cancelUserChanges.bind(this)}
                    >
                      CANCEL
                    </Button>
                    <Button
                      variant="contained"
                      onClick={this.updateUserProfile.bind(this)}
                      style={sendBtn}
                    >
                      <SendIcon className={classes.rightIcon} />
                      &nbsp; UPDATE PROFILE
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </TabContainer>
          )}
          {value === 1 && (
            <TabContainer>
              <div>
                <Grid container spacing={8}>
                  <Grid item xs={12}>
                    <FormGroup row>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                        fullWidth
                      >
                        <FormLabel
                          component="small"
                          className={classes.subscribeHeading}
                        >
                          Receive email notifications for new posts?
                        </FormLabel>
                        <RadioGroup
                          aria-label="subscribePosts"
                          name="receiveEmails"
                          className={classes.group}
                          value={String(this.state.receiveEmails)}
                          onChange={this.handleChange("receiveEmails").bind(
                            this
                          )}
                        >
                          <FormControlLabel
                            value={"true"}
                            control={<Radio />}
                            label="Subscribe"
                          />
                          <FormControlLabel
                            value={"false"}
                            control={<Radio />}
                            label="Unsubscribe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </FormGroup>
                    <FormGroup row>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                        fullWidth
                      >
                        <FormLabel
                          component="small"
                          className={classes.subscribeHeading}
                        >
                          Receive email notifications for Personal Development Plan?
                        </FormLabel>
                        <RadioGroup
                          aria-label="subscribePosts"
                          name="receivePLDPEmails"
                          className={classes.group}
                          value={String(this.state.receivePLDPEmails)}
                          onChange={this.handleChange("receivePLDPEmails").bind(
                            this
                          )}
                        >
                          <FormControlLabel
                            value={"true"}
                            control={<Radio />}
                            label="Subscribe"
                          />
                          <FormControlLabel
                            value={"false"}
                            control={<Radio />}
                            label="Unsubscribe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </FormGroup>

                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      style={{ backgroundColor: RED, color: "#fff" }}
                      onClick={this.cancelUserChanges.bind(this)}
                    >
                      CANCEL
                    </Button>
                    <Button
                      variant="contained"
                      style={sendBtn}
                      onClick={this.updateUserProfile.bind(this)}
                    >
                      <SendIcon className={classes.rightIcon} />
                      &nbsp;UPDATE SUBSCRIPTION
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </TabContainer>
          )}
{value === 2 && (
  <div>
    {!this.state.walletAccessGranted && this.state.totpEnabled ? (
      // Case 2: TOTP enabled but wallet access not yet granted - Show OTP verification
      <div style={{
        padding: '20px',
        backgroundColor: '#e3f2fd',
        border: '2px solid #2196f3',
        borderRadius: '8px',
        marginTop: '16px'
      }}>
        <Typography variant="h6" style={{
          color: '#0d47a1',
          fontWeight: 'bold',
          marginBottom: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          🔐 Verify Your Identity
        </Typography>
        <Typography variant="body2" style={{
          color: '#0d47a1',
          marginBottom: '15px'
        }}>
          Enter the current code from Google Authenticator to modify your Google Authenticator.
        </Typography>
        <TextField
          fullWidth
          label="Enter 6-digit TOTP Code"
          value={this.state.walletOTPCode}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, '').slice(0, 6);
            this.setState({ walletOTPCode: value });
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && this.state.walletOTPCode.length === 6) {
              this.verifyWalletOTP();
            }
          }}
          inputProps={{
            maxLength: 6,
            style: {
              fontSize: '24px',
              letterSpacing: '8px',
              textAlign: 'center',
              fontWeight: 'bold'
            }
          }}
          placeholder="000000"
          style={{ marginBottom: '15px' }}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={this.verifyWalletOTP}
          disabled={this.state.walletOTPCode.length !== 6 || this.state.isVerifyingWalletOTP}
          style={{
            padding: '12px',
            fontWeight: 'bold'
          }}
        >
          {this.state.isVerifyingWalletOTP ? 'Verifying...' : 'Verify & Access Wallet'}
        </Button>
      </div>
    ) : (
      // Case 3: TOTP verified (walletAccessGranted) OR TOTP not enabled - Show full security settings
            <TabContainer>
              <div>
                <Typography variant="h6" gutterBottom style={{ color: LIGHTBLUE, marginBottom: '20px' }}>
                  Security Settings
                </Typography>

                {/* TOTP Status Warning */}
                {!this.state.totpEnabled && this.state.defaultSecurityLevel === 'level1' && (
                  <div style={{
                    marginBottom: '20px',
                    padding: '15px',
                    backgroundColor: '#fff3cd',
                    border: '2px solid #ffc107',
                    borderRadius: '8px'
                  }}>
                    <Typography variant="h6" style={{
                      fontWeight: 'bold',
                      marginBottom: '10px',
                      color: '#856404',
                      textAlign: 'center'
                    }}>
                      ⚠️ BASIC SECURITY WARNING
                    </Typography>

                    <Typography variant="body2" style={{
                      marginBottom: '10px',
                      color: '#856404',
                      textAlign: 'center'
                    }}>
                      <strong>Google Authenticator not enabled!</strong>
                      <br />Your security level is set to Level 1 (Basic).
                    </Typography>

                    <Typography variant="body2" style={{
                      color: '#856404',
                      textAlign: 'center',
                      fontStyle: 'italic'
                    }}>
               💡 <strong>Important:</strong> Setup Google Authenticator with TOTP protection on <b>Level 2</b>. Once enabled, you can set your security level back to Level 1 if you so prefer. We reccommend keeping it on level 2.                    </Typography>
                  </div>
                )}

                {/* TOTP Present Confirmation */}
                {this.state.totpEnabled && (
                  <div style={{
                    marginBottom: '20px',
                    padding: '15px',
                    backgroundColor: '#e8f5e8',
                    border: '2px solid #4caf50',
                    borderRadius: '8px'
                  }}>
                    <Typography variant="body2" style={{
                      color: '#2e7d32',
                      textAlign: 'center',
                      fontWeight: 'bold'
                    }}>
                      ✅ <strong>Google Authenticator Enabled</strong>
                      <br />Enhanced security is active. Level 2 security available.
                    </Typography>
                  </div>
                )}

                <Grid container spacing={8}>
                  <Grid item xs={12}>
                    <FormGroup row>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                        fullWidth
                      >
                        <FormLabel
                          component="small"
                          className={classes.subscribeHeading}
                          style={{ fontWeight: 'bold', marginBottom: '10px' }}
                        >
                          Default Security Level
                        </FormLabel>
                        <Typography variant="body2" style={{ marginBottom: '15px', color: '#666' }}>
                          Choose your preferred security level for login. You can always change this on the login screen.
                        </Typography>

                        <div style={{ marginBottom: '20px' }}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <FormControlLabel
                              value="level1"
                              control={
                                <Radio
                                  checked={this.state.defaultSecurityLevel === 'level1'}
                                  onChange={(e) => {
                                    this.setState({
                                      defaultSecurityLevel: 'level1',
                                      receiveWhatsAppSecurity: false, // Automatically disable WhatsApp OTP for Level 1
                                      unsavedchanges: true
                                    });
                                  }}
                                />
                              }
                              label={
                                <div>
                                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                    Level 1: Standard Login
                                  </Typography>
                                  <Typography variant="caption" style={{ color: '#666' }}>
                                    Email and password only (faster login, lower security)
                                  </Typography>
                                </div>
                              }
                            />


                            <FormControlLabel
                              value="level2"
                              control={
                                <Radio
                                  checked={this.state.defaultSecurityLevel === 'level2'}
                                  onChange={(e) => {
                                    // Allow users to select Level 2 even without TOTP
                                    // They can then set it up using the interface below
                                    this.setState({
                                      defaultSecurityLevel: 'level2',
                                      unsavedchanges: true
                                    });
                                  }}
                                />
                              }
                              label={
                                <div>
                                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                    Level 2: Secure Login (Recommended)
                                  </Typography>
                                  <Typography variant="caption" style={{ color: '#666' }}>
                                    Email + password + Google Authenticator TOTP (higher security)
                                  </Typography>
                                  {!this.state.totpEnabled && (
                                    <Typography variant="caption" style={{
                                      display: 'block',
                                      color: '#dc3545',
                                      fontWeight: 'bold'
                                    }}>
                                      ⚠️ Requires Google Authenticator setup
                                    </Typography>
                                  )}
                                </div>
                              }
                            />


                            {/* LEVEL 3 SECURITY - COMMENTED OUT (no longer using)
                            <FormControlLabel
                              value="level3"
                              control={
                                <Radio 
                                  checked={this.state.defaultSecurityLevel === 'level3'}
                                  onChange={(e) => {
                                    const hasPhoneNumber = this.state.cellphone && this.state.cellphone.trim() !== '';
                                    
                                    if (hasPhoneNumber) {
                                      this.setState({ 
                                        defaultSecurityLevel: 'level3',
                                        receiveWhatsAppSecurity: true,
                                        unsavedchanges: true
                                      });
                                    } else {
                                      alert('⚠️ PHONE NUMBER REQUIRED\n\nLevel 3 security requires a valid phone number.\n\nPlease add your phone number first, then select Level 3.');
                                      this.setState({ 
                                        defaultSecurityLevel: 'level1',
                                        receiveWhatsAppSecurity: false,
                                        unsavedchanges: true
                                      });
                                    }
                                  }}
                                />
                              }
                              label={
                                <div>
                                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                    Level 3: Maximum Security
                                  </Typography>
                                  <Typography variant="caption" style={{ color: '#666' }}>
                                    Level 2 features + OTP for sensitive actions (buying/selling MEV coins)
                                  </Typography>
                                  {(!this.state.cellphone || this.state.cellphone.trim() === '') && (
                                    <Typography variant="caption" style={{ 
                                      display: 'block',
                                      color: '#dc3545',
                                      fontWeight: 'bold'
                                    }}>
                                      ⚠️ Requires phone number
                                    </Typography>
                                  )}
                                </div>
                              }
                            />
                            */}
                          </div>

                          <Typography variant="caption" style={{
                            display: 'block',
                            marginTop: '10px',
                            color: '#6c757d',
                            fontStyle: 'italic'
                          }}>
                            {this.state.defaultSecurityLevel === 'level1'
                              ? '⚠️ Level 1: Faster but less secure - Only email and password required'
                              : '🛡️ Level 2: Enhanced security - Google Authenticator TOTP verification'
                            }
                          </Typography>
                        </div>
                      </FormControl>
                    </FormGroup>
                  </Grid>

                  {/* TOTP (Google Authenticator) Setup - Shows when Level 2 is selected */}
                  {this.state.defaultSecurityLevel === 'level2' && (
                    <Grid item xs={12}>
                      <div style={{
                        marginTop: '20px',
                        marginBottom: '20px',
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        border: '2px solid #007bff',
                        borderRadius: '8px'
                      }}>
                        <Typography variant="h6" style={{
                          fontWeight: 'bold',
                          marginBottom: '15px',
                          color: '#007bff',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px'
                        }}>
                          🔐 Google Authenticator (TOTP)
                          {this.state.totpEnabled && (
                            <span style={{
                              fontSize: '14px',
                              color: '#28a745',
                              backgroundColor: '#d4edda',
                              padding: '4px 12px',
                              borderRadius: '12px',
                              border: '1px solid #28a745'
                            }}>
                              ✅ Enabled
                            </span>
                          )}
                        </Typography>

                        <Typography variant="body2" style={{
                          marginBottom: '15px',
                          color: '#666'
                        }}>
                          Set up Time-based One-Time Password (TOTP) authentication using Google Authenticator for Level 2 security.
                        </Typography>

                        {!this.state.totpEnabled && !this.state.showTOTPSetup && (
                          <Button
                            variant="contained"
                            onClick={this.generateTOTPSecret}
                            style={{
                              backgroundColor: '#007bff',
                              color: '#fff',
                              fontWeight: 'bold',
                              textTransform: 'none',
                              padding: '10px 20px'
                            }}
                          >
                            🔑 Setup Google Authenticator
                          </Button>
                        )}

                        {this.state.totpEnabled && (
                          <div>
                            <Typography variant="body2" style={{
                              marginBottom: '15px',
                              color: '#28a745',
                              fontWeight: 'bold'
                            }}>
                              ✅ Google Authenticator is enabled for your account.
                            </Typography>

                            <div style={{
                              marginTop: '10px',
                              padding: '15px',
                              backgroundColor: '#fff',
                              border: '1px solid #ddd',
                              borderRadius: '5px'
                            }}>
                              <Typography variant="body2" style={{
                                marginBottom: '10px',
                                fontWeight: 'bold',
                                color: '#333'
                              }}>
                                Your TOTP Secret:
                              </Typography>

                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                marginBottom: '10px'
                              }}>
                                <TextField
                                  value={this.state.showTOTPSecret ? this.state.totpSecret : '•'.repeat(32)}
                                  InputProps={{
                                    readOnly: true,
                                    style: {
                                      fontFamily: 'monospace',
                                      fontSize: '14px',
                                      backgroundColor: '#f8f9fa'
                                    }
                                  }}
                                  fullWidth
                                  variant="outlined"
                                  size="small"
                                />

                                <IconButton
                                  onClick={this.toggleShowTOTPSecret}
                                  style={{ color: '#007bff' }}
                                  title={this.state.showTOTPSecret ? "Hide Secret" : "Show Secret"}
                                >
                                  {this.state.showTOTPSecret ? <VisibilityOff /> : <Visibility />}
                                </IconButton>

                                <IconButton
                                  onClick={this.copyTOTPSecret}
                                  style={{ color: '#28a745' }}
                                  title="Copy Secret"
                                >
                                  <ContentCopy />
                                </IconButton>
                              </div>

                              <Typography variant="caption" style={{
                                color: '#666',
                                fontStyle: 'italic',
                                display: 'block',
                                marginBottom: '10px'
                              }}>
                                💡 You can manually enter this secret in Google Authenticator if needed.
                              </Typography>
                            </div>

                            {/* TOTP Verification Section */}
                            <div style={{
                              marginTop: '20px',
                              padding: '20px',
                              backgroundColor: '#e3f2fd',
                              border: '2px solid #2196f3',
                              borderRadius: '8px'
                            }}>
                              <Typography variant="h6" style={{
                                fontWeight: 'bold',
                                marginBottom: '10px',
                                color: '#1976d2',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                              }}>
                                🧪 Test Your TOTP
                              </Typography>

                              <Typography variant="body2" style={{
                                marginBottom: '15px',
                                color: '#1976d2'
                              }}>
                                Enter the 6-digit code from your Google Authenticator app to verify it's working:
                              </Typography>

                              <div style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                                marginBottom: '10px'
                              }}>
                                <TextField
                                  variant="outlined"
                                  placeholder="Enter 6-digit code"
                                  value={this.state.totpVerificationCode}
                                  onChange={(event) => {
                                    const { value } = event.target;
                                    // Only allow numbers and max 6 digits
                                    if (/^\d{0,6}$/.test(value)) {
                                      this.setState({ totpVerificationCode: value });
                                    }
                                  }}
                                  disabled={this.state.isVerifyingTOTP}
                                  inputProps={{
                                    maxLength: 6,
                                    pattern: "[0-9]*",
                                    inputMode: "numeric",
                                    style: {
                                      textAlign: 'center',
                                      fontSize: '20px',
                                      fontWeight: 'bold',
                                      letterSpacing: '8px',
                                      fontFamily: 'monospace'
                                    }
                                  }}
                                  style={{
                                    backgroundColor: '#fff',
                                    width: '250px'
                                  }}
                                />

                                <Button
                                  variant="contained"
                                  onClick={this.verifyTOTPCode}
                                  disabled={this.state.isVerifyingTOTP || this.state.totpVerificationCode.length !== 6}
                                  style={{
                                    backgroundColor: this.state.totpVerificationCode.length === 6 ? '#2196f3' : '#ccc',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    textTransform: 'none',
                                    padding: '12px 30px',
                                    minWidth: '150px'
                                  }}
                                >
                                  {this.state.isVerifyingTOTP ? '🔄 Verifying...' : '✅ Verify Code'}
                                </Button>
                              </div>

                              <Typography variant="caption" style={{
                                color: '#1976d2',
                                fontStyle: 'italic',
                                display: 'block'
                              }}>
                                💡 Tip: Open Google Authenticator and enter the current 6-digit code shown for ThinkLead
                              </Typography>
                            </div>

                            <Button
                              variant="outlined"
                              onClick={this.disableTOTP}
                              style={{
                                marginTop: '15px',
                                borderColor: '#dc3545',
                                color: '#dc3545',
                                textTransform: 'none'
                              }}
                            >
                              ❌ Disable Google Authenticator
                            </Button>
                          </div>
                        )}

                        {this.state.showTOTPSetup && !this.state.totpEnabled && (
                          <div style={{
                            marginTop: '20px',
                            padding: '20px',
                            backgroundColor: '#fff',
                            border: '2px solid #007bff',
                            borderRadius: '8px'
                          }}>
                            <Typography variant="h6" style={{
                              fontWeight: 'bold',
                              marginBottom: '15px',
                              color: '#007bff',
                              textAlign: 'center'
                            }}>
                              📱 Setup Google Authenticator
                            </Typography>

                            <Typography variant="body2" style={{
                              marginBottom: '20px',
                              color: '#666',
                              textAlign: 'center'
                            }}>
                              <strong>Step 1:</strong> Install Google Authenticator on your phone
                              <br />
                              <strong>Step 2:</strong> Scan the QR code below OR manually enter the secret key
                            </Typography>

                            {this.state.totpQRCode && (
                              <div style={{
                                textAlign: 'center',
                                marginBottom: '20px',
                                padding: '20px',
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                                border: '2px dashed #007bff'
                              }}>
                                <Typography variant="body2" style={{
                                  marginBottom: '15px',
                                  fontWeight: 'bold',
                                  color: '#333'
                                }}>
                                  📷 Scan this QR Code with Google Authenticator:
                                </Typography>
                                <img
                                  src={this.state.totpQRCode}
                                  alt="TOTP QR Code"
                                  style={{
                                    maxWidth: '250px',
                                    border: '3px solid #007bff',
                                    borderRadius: '8px',
                                    padding: '10px',
                                    backgroundColor: '#fff'
                                  }}
                                />
                              </div>
                            )}

                            <div style={{
                              marginBottom: '20px',
                              padding: '15px',
                              backgroundColor: '#f8f9fa',
                              border: '1px solid #ddd',
                              borderRadius: '5px'
                            }}>
                              <Typography variant="body2" style={{
                                marginBottom: '10px',
                                fontWeight: 'bold',
                                color: '#333'
                              }}>
                                🔑 Manual Entry Code:
                              </Typography>

                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                              }}>
                                <TextField
                                  value={this.state.totpSecret}
                                  InputProps={{
                                    readOnly: true,
                                    style: {
                                      fontFamily: 'monospace',
                                      fontSize: '16px',
                                      fontWeight: 'bold',
                                      backgroundColor: '#fff',
                                      letterSpacing: '2px'
                                    }
                                  }}
                                  fullWidth
                                  variant="outlined"
                                />

                                <IconButton
                                  onClick={this.copyTOTPSecret}
                                  style={{
                                    backgroundColor: '#28a745',
                                    color: '#fff',
                                    padding: '12px'
                                  }}
                                  title="Copy Secret"
                                >
                                  <ContentCopy />
                                </IconButton>
                              </div>

                              <Typography variant="caption" style={{
                                color: '#666',
                                fontStyle: 'italic',
                                display: 'block',
                                marginTop: '10px'
                              }}>
                                💡 If you can't scan the QR code, manually enter this secret key in Google Authenticator.
                              </Typography>
                            </div>

                            <div style={{
                              marginTop: '20px',
                              padding: '15px',
                              backgroundColor: '#fff3cd',
                              border: '1px solid #ffc107',
                              borderRadius: '5px'
                            }}>
                              <Typography variant="body2" style={{
                                color: '#856404',
                                fontWeight: 'bold',
                                marginBottom: '10px'
                              }}>
                                ⚠️ Important Instructions:
                              </Typography>
                              <Typography variant="body2" style={{ color: '#856404' }}>
                                1. Open Google Authenticator on your phone
                                <br />
                                2. Tap the "+" button to add a new account
                                <br />
                                3. Choose "Scan a QR code" or "Enter a setup key"
                                <br />
                                4. Scan the QR code above or manually enter the secret key
                                <br />
                                5. Your account will be added with 6-digit codes that change every 30 seconds
                                <br />
                                <br />
                                <strong>⚠️ SAVE THIS SECRET KEY SECURELY!</strong>
                                <br />
                                If you lose your phone, you'll need this key to recover access.
                              </Typography>
                            </div>

                            <div style={{
                              display: 'flex',
                              gap: '10px',
                              justifyContent: 'center',
                              marginTop: '20px'
                            }}>
                              <Button
                                variant="contained"
                                onClick={this.saveTOTPSecret}
                                style={{
                                  backgroundColor: '#28a745',
                                  color: '#fff',
                                  fontWeight: 'bold',
                                  textTransform: 'none',
                                  padding: '12px 30px'
                                }}
                              >
                                ✅ Save & Enable TOTP
                              </Button>

                              <Button
                                variant="outlined"
                                onClick={() => this.setState({
                                  showTOTPSetup: false,
                                  totpSecret: '',
                                  totpQRCode: ''
                                })}
                                style={{
                                  borderColor: '#dc3545',
                                  color: '#dc3545',
                                  textTransform: 'none'
                                }}
                              >
                                ❌ Cancel
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                    </Grid>
                  )}
                  {/* END OF TOTP COMPONENT */}

                  {/* WHATSAPP OTP SECTION - COMMENTED OUT (no longer using)
                  <Grid item xs={12}>
                    <FormGroup row>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                        fullWidth
                      >
                        <FormLabel
                          component="small"
                          className={classes.subscribeHeading}
                          style={{ fontWeight: 'bold', marginBottom: '10px' }}
                        >
                          OTP Delivery Method
                        </FormLabel>
                        <Typography variant="body2" style={{ marginBottom: '15px', color: '#666' }}>
                          Enable WhatsApp OTP for secure login verification. When enabled, you'll need to enter a code from WhatsApp to complete login.
                        </Typography>
                        ...
                        [WhatsApp OTP checkbox and related UI - COMMENTED OUT]
                        ...
                      </FormControl>
                    </FormGroup>
                  </Grid>
                  */}

                  <Grid item xs={12}>
                    <Typography variant="body2" style={{
                      backgroundColor: '#f5f5f5',
                      padding: '15px',
                      borderRadius: '5px',
                      border: '1px solid #ddd',
                      marginTop: '20px'
                    }}>
                      <strong>Security Tips:</strong>
                      <br />• Keep your password strong and unique
                      <br />• Google Authenticator provides secure 2FA verification
                      <br />• Never share your login credentials or TOTP codes with others
                      <br />• Save your TOTP secret key in a secure location
                      <br />• Log out from shared devices after use
                      <br />• TOTP codes change every 30 seconds - use current codes
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      style={{ backgroundColor: RED, color: "#fff", marginRight: '10px' }}
                      onClick={this.cancelUserChanges.bind(this)}
                    >
                      CANCEL
                    </Button>
                    <Button
                      variant="contained"
                      style={sendBtn}
                      onClick={this.updateUserProfile.bind(this)}
                    >
                      <SendIcon className={classes.rightIcon} />
                      &nbsp;UPDATE SECURITY SETTINGS
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </TabContainer>
    )}
  </div>
)}
          {value === 3 && (
            <TabContainer>
              <div>
                <Grid container spacing={8}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="password"
                      type={this.state.showPassword ? "text" : "password"}
                      label="New password"
                      value={this.state.password}
                      helperText={this.handlePasswordStrength(
                        this.state.password
                      )}
                      fullWidth
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      onChange={this.handleChange("password")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="Toggle password visibility"
                              onClick={this.handleClickShowPassword}
                            >
                              {this.state.showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="confirmpassword"
                      type={
                        this.state.showConfirmPassword ? "text" : "password"
                      }
                      fullWidth
                      label="Confirm password"
                      value={this.state.confirmPassword}
                      helperText={this.handlePasswordStrength(
                        this.state.confirmPassword
                      )}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      onChange={this.handleChange("confirmPassword")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="Toggle password visibility"
                              onClick={this.handleClickConfirmPassword}
                            >
                              {this.state.showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Button
                      variant="contained"
                      style={{ backgroundColor: RED, color: "#fff" }}
                      onClick={this.cancelUserChanges.bind(this)}
                    >
                      CANCEL
                    </Button>
                    <Button
                      variant="contained"
                      style={sendBtn}
                      onClick={this.changeUserPassword.bind(this)}
                    >
                      <SendIcon className={classes.rightIcon} />
                      &nbsp;UPDATE PASSWORD
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </TabContainer>
          )}
          {value === 4 && (
            <TabContainer>
              <div><b>Opinion Polls</b></div>
              <div>
                <MDBContainer>
                  <MDBRow>
                    <MDBCol style={tableC} >
                      <b> Opinion</b>
                    </MDBCol>
                    <MDBCol style={tableC} >
                      <b> Mean Score</b>
                    </MDBCol>
                    <MDBCol style={tableC} >
                      <b> Participants</b>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol style={tableM} >
                      <b>Leading Self:</b>
                    </MDBCol>
                    <MDBCol style={tableM} >
                      {this.state.self}
                    </MDBCol>
                    <MDBCol style={tableMh} >
                      {this.state.selfparticipants}
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    {opinions && Object.keys(opinions).length > 0 ?
                      <b><i>List of Feedback on Leading Self: </i></b>
                      : null}
                  </MDBRow>
                  {opinions && Object.keys(opinions).map((opinionsID, index) => {
                    return (
                      <React.Fragment>
                        <MDBRow>
                          <MDBCol style={tableH}>
                            {opinions[index].selfopinion}
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol >
                            &nbsp;&nbsp;
                          </MDBCol>
                        </MDBRow>
                      </React.Fragment>
                    )
                  })}

                  <MDBRow>
                    <MDBCol style={tableMh} >
                      <b> Leading Others:</b>
                    </MDBCol>
                    <MDBCol style={tableM} >
                      {this.state.others}
                    </MDBCol>
                    <MDBCol style={tableM} >
                      {this.state.othersparticipants}
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    {opinions && Object.keys(opinions).length > 0 ?
                      <b><i>List of Feedback on Leading Others</i></b>
                      : null}
                  </MDBRow>
                  {opinions && Object.keys(opinions).map((opinionsID, index) => {
                    return (
                      <React.Fragment>
                        <MDBRow>
                          <MDBCol style={tableH}>
                            {opinions[index].othersopinion}
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol>
                            &nbsp;&nbsp;
                          </MDBCol>
                        </MDBRow>
                      </React.Fragment>
                    )
                  })}

                  <MDBRow>
                    <MDBCol style={tableMh} >
                      <b> Leading Organisation:</b>
                    </MDBCol>
                    <MDBCol style={tableM} >
                      {this.state.organisation}
                    </MDBCol>
                    <MDBCol style={tableM} >
                      {this.state.orgparticipants}
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    {opinions && Object.keys(opinions).length > 0 ?
                      <b><i>List of Feedback on Leading Organisation</i></b>
                      : null}
                  </MDBRow>
                  {opinions && Object.keys(opinions).map((opinionsID, index) => {
                    return (
                      <React.Fragment>
                        <MDBRow>
                          <MDBCol style={tableH}>
                            {opinions[index].orgopinion}
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol>
                            &nbsp;&nbsp;
                          </MDBCol>
                        </MDBRow>
                      </React.Fragment>
                    )
                  })}

                  <MDBRow>
                    <MDBCol style={tableMh} >
                      <b> Leading Society:</b>
                    </MDBCol>
                    <MDBCol style={tableM} >
                      {this.state.society}
                    </MDBCol>
                    <MDBCol style={tableM} >
                      {this.state.sosparticipants}
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    {opinions && Object.keys(opinions).length > 0 ?
                      <b><i>List of Feedback on leading Society</i></b>
                      : null}
                  </MDBRow>
                  {opinions && Object.keys(opinions).map((opinionsID, index) => {
                    return (
                      <React.Fragment>
                        <MDBRow>
                          <MDBCol style={tableH}>
                            {opinions[index].sosopinion}
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol>
                            &nbsp;&nbsp;
                          </MDBCol>
                        </MDBRow>
                      </React.Fragment>
                    )
                  })}

                </MDBContainer>
              </div>
            </TabContainer>
          )}
        </div>
      </NoSsr >
    );
  }
}

const sendBtn = {
  backgroundColor: LIGHTBLUE,
  color: "#fff",
  margin: "8px"
};

UserTabs.propTypes = {
  classes: PropTypes.object.isRequired
};

const userTabsStyled = withStyles(styles)(UserTabs);

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    UPDATE_USER: state.userDialog.UPDATE_USER,
    company_settings: state.users.company_settings,
    general_settings: state.users.general_settings,
    opinions: state.opinions.opinion
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showToast: params => dispatch(showToast(params)),
    clearStates: params => dispatch(clearStates(params)),
    updateProfileChanges: params => dispatch(updateUserProfile(params)),
    updateUserPassword: params => dispatch(updateUserPassword(params)),
    showUserProfile: params => dispatch(showUserProfile(params)),
    getAllCompanySettings: params => dispatch(getAllCompanySettings(params)),
    getAllGeneralSettings: params => dispatch(getAllGeneralSettings(params)),
    //getOpinions: params => dispatch(getOpinions(params)),
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return bindActionCreators({
//     showToast,
//     clearStates,
//     updateProfileChanges,
//     updateUserPassword,
//     showUserProfile,
//     getAllCompanySettings
//   }, dispatch)
// }

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(userTabsStyled)
);
